export const versionOptions = (results) => {
  let filteredResults = new Set();

  // Remove any version results with duplicate 'name' values
  const versionOptionsArr = results
    .filter((result) => {
      return (
        !filteredResults.has(result['name']) &&
        filteredResults.add(result['name'])
      );
    })
    .map((result) => ({
      value: result.hamId,
      label: result.name,
    }));

  return {
    version: versionOptionsArr,
  };
};
